import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.models';
import { navigate } from './router.actions';
import { Sort } from '@angular/material/sort';
import { ParamsKey } from './router.models';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class RouterService {
    constructor(private store: Store<AppState>) {}

    setFilter(filter: string) {
        this.store.dispatch(
            navigate({
                url: [],
                queryParams: {
                    [ParamsKey.FILTER]: filter && filter.length > 0 && filter !== '' ? filter : undefined,
                    [ParamsKey.PAGE]: 0,
                },
            })
        );
    }

    setSortParams(event: Sort) {
        this.store.dispatch(
            navigate({
                url: [],
                queryParams: {
                    [ParamsKey.SORT_COLUMN]: event.active,
                    [ParamsKey.SORT_ASC]: event.direction === 'asc' ? true : false,
                    [ParamsKey.PAGE]: 0,
                },
            })
        );
    }
    setPageParams(event: PageEvent) {
        this.store.dispatch(
            navigate({
                url: [],
                queryParams: {
                    [ParamsKey.ROW_LIMIT]: event.pageSize,
                    [ParamsKey.PAGE]: event.pageIndex,
                },
            })
        );
    }
}
